<template>
  <div id="app">
    <div class="blackout" :class="{ isBlackedOut }"></div>
    <header role="banner" class="header clearfix" ref="siteHeader">
      <button
        type="button"
        aria-label="Open Menu"
        class="header__mobile-btn float-right"
        @click="toggleMobileMenu">
        {{ mobileMenutext }}
      </button>
      <div class="header__container">
        <MainNavigation
          :class="{ isOpen: isOpen }"
          @closeNav="closeNav">
        </MainNavigation>
      </div>
    </header>
    <router-view/>
    <footer>
      <ul class="footer-list">
        <li>Berries And Blooms &copy; 2017</li>
        <li>
          <a href="mailto:info@berriesandblooms.co.za?Subject=Hello">
            info@berriesandblooms.co.za
          </a>
        </li>
      </ul>
    </footer>
  </div>
</template>

<script>
import MainNavigation from '@/components/MainNavigation'

export default {
  name: 'app',
  components: {
    MainNavigation,
  },
  data () {
    return {
      mobileMenutext: 'Sections',
      isOpen: false,
      isBlackedOut: false,
    }
  },
  methods: {
    closeNav () {
      this.mobileMenutext = 'Sections'
      this.isBlackedOut = false
      this.isOpen = false
    },
    openMobileMenu () {
      this.mobileMenutext = 'Close'
      this.isBlackedOut = true
      this.isOpen = true
    },
    closeMobileMenu () {
      this.mobileMenutext = 'Sections'
      this.isBlackedOut = false
      this.isOpen = false
    },
    toggleMobileMenu () {
      if (this.isOpen) {
        this.closeMobileMenu()
      } else {
        this.openMobileMenu()
      }
    },
  },
}
</script>

<style lang="scss">
  @import url('https://fonts.googleapis.com/css?family=Poppins:200,300,400,500,700');

  body, html {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    background: center/cover white;
    font-family: 'Poppins', sans-serif !important;
    min-height: 100vh;
    margin: 0;
    padding: 0;
    position: relative;
  }

  #app {
    min-height: 100vh;
    position: relative;
    width: 100%;
    margin: 0;
    margin-bottom: 100px;
  }

  .center-container {
    margin: 0 auto;
    min-height: 70vh;
    padding: 0 30px;
    position: relative;

    @include media-breakpoint-up(md) {
      min-height: 65vh;
    }

    @include media-breakpoint-up(lg) {
      min-height: 50vh;
      padding: 0;
    }

    &.flex-center {
      align-items: center;
      display: flex;
      justify-content: center;
    }

    &.has-margin-top {
      padding: 75px 30px;
    }

    &.has-width {
      @include media-breakpoint-up(xl) {
        max-width: 1028px;
      }

      @include media-breakpoint-up(xxl) {
        max-width: 1280px;
      }
    }
    &.has-gradient {
      @include media-breakpoint-up(xl) {
        &::after,
        &::before {
          background: linear-gradient(to bottom, rgba($white, 0) 0%,rgba($white, 1) 100%);
          bottom: 0;
          content: '';
          height: 100%;
          position: absolute;
          width: 570px;
          z-index: 4;
        }

        &::after {
          right: 0;
        }

        &::before {
          left: 0;
        }
      }
    }

    .center-container__left-figure,
    .center-container__right-figure {
      display: none;

      @include media-breakpoint-up(xl) {
        display: block;
        position: absolute;
        top: 42%;
        transform: translateY(-50%);
        width: 30%;
        z-index: 0;
      }
    }

    .center-container__left-figure {
      left: 0;
    }

    .center-container__right-figure {
      right: 0;
    }

    .center-container__content {
      animation: fade-in-bottom .6s cubic-bezier(.390, .575, .565, 1) both;
      max-width: 680px;
      position: relative;
      text-align: center;
      z-index: 5;

      .center-container__logo {
        margin-top: 110px;
        width: 100%;

        @include media-breakpoint-up(md) {
          width: 30%;
        }

        @include media-breakpoint-up(xl) {
          margin-top: 90px;
        }

        @include media-breakpoint-up(xxl) {
          width: 40%;
        }
      }

      .center-container__title,
      .center-container__intro-text {
        color: #9a9999;
        font-size: 1rem;
        font-weight: 400;
        line-height: 1.5;

        @include media-breakpoint-up(xl) {
          font-size: 1.2rem;
          letter-spacing: 1px;
        }
      }
    }
  }
</style>
